// BrandLockup — F2C Academy brand mark (icon + wordmark), shared across
// all post-login student pages so the brand never drops out as a student
// moves between the Dashboard, Learn, and Solution screens.
//
// Variants:
//   variant="light" — for light-background headers (Dashboard, Learn).
//   variant="dark"  — for dark-background headers (Solution / IDE chrome).
// The icon SVG uses fixed brand colours that read on both backgrounds;
// only the "Academy" wordmark switches (slate-800 ↔ slate-100) for contrast.

import React from 'react';
import { Link } from 'react-router-dom';

export const F2CLogoMark = ({ className = 'w-9 h-9' }) => (
  <div className={className}>
    <svg viewBox="0 0 64 64" fill="none" className="w-full h-full">
      <path d="M8 20 Q20 8 32 16" stroke="#3b82f6" strokeWidth="3" fill="none" strokeLinecap="round"/>
      <circle cx="8" cy="20" r="4" fill="#3b82f6"/>
      <path d="M26 28L22 34L26 40" stroke="#f97316" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M38 28L42 34L38 40" stroke="#f97316" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M50 44L40 50L50 56L60 50L50 44Z" fill="#10b981"/>
      <path d="M44 52V58" stroke="#10b981" strokeWidth="2"/>
      <path d="M56 52V58" stroke="#10b981" strokeWidth="2"/>
      <circle cx="60" cy="52" r="2" fill="#f97316"/>
      <path d="M60 50V54" stroke="#f97316" strokeWidth="1.5"/>
      <path d="M32 18L28 24" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" strokeDasharray="2 2"/>
      <path d="M42 38L46 44" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" strokeDasharray="2 2"/>
    </svg>
  </div>
);

export const F2CWordmark = ({ variant = 'light', className = '' }) => {
  const academyClass = variant === 'dark' ? 'text-slate-100' : 'text-slate-800';
  return (
    <span className={`text-xl font-bold tracking-tight ${className}`}>
      <span className="text-blue-600">F</span>
      <span className="text-orange-500">2</span>
      <span className="text-emerald-500">C</span>
      <span className={`ml-1 ${academyClass}`}>Academy</span>
    </span>
  );
};

export const BrandLockup = ({
  variant      = 'light',
  href         = '/dashboard',
  className    = '',
  withWordmark = true,
  markClassName,
}) => (
  <Link
    to={href}
    className={`flex items-center gap-2.5 flex-shrink-0 ${className}`}
    data-testid="brand-lockup"
  >
    <F2CLogoMark className={markClassName} />
    {withWordmark && <F2CWordmark variant={variant} />}
  </Link>
);

export default BrandLockup;
